import { render, staticRenderFns } from "./menuTitle.vue?vue&type=template&id=ad124fe8&scoped=true"
import script from "./menuTitle.vue?vue&type=script&lang=js"
export * from "./menuTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad124fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad124fe8')) {
      api.createRecord('ad124fe8', component.options)
    } else {
      api.reload('ad124fe8', component.options)
    }
    module.hot.accept("./menuTitle.vue?vue&type=template&id=ad124fe8&scoped=true", function () {
      api.rerender('ad124fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/menuTitle.vue"
export default component.exports